module.exports = __webpack_public_path__ + "img/course-14.e722a795.png";